import React, { Component,Fragment } from 'react';
import Breadcrumb from './common/breadcrumb';
import { Navigation, Box, MessageSquare, Users, DollarSign, BookOpen, ShoppingBag , List, Briefcase, CreditCard, ShoppingCart, Calendar } from 'react-feather';
import CountUp from 'react-countup';
import { Chart } from "react-google-charts";
import CanvasJSReact from '../assets/canvas/canvasjs.react';
import '../assets/css/dashboard.css'
import { Pie, Doughnut, Bar, Line } from 'react-chartjs-2';
import { 
    pieOptions, 
    doughnutOption, 
    lineOptions, 
    buyOption, 
    employeeData, 
    employeeOptions 
} from '../constants/chartData'
// image impoer
import user2 from '../assets/images/dashboard/user2.jpg';
import user1 from '../assets/images/dashboard/user1.jpg';
import man from '../assets/images/dashboard/man.png';
import user from '../assets/images/dashboard/user.png';
import designer from '../assets/images/dashboard/designer.jpg'
var CanvasJS = CanvasJSReact.CanvasJS;
var CanvasJSChart = CanvasJSReact.CanvasJSChart;


export class Dashboard extends Component {
    constructor(props){
        super(props)
        this.state={
            categoryCount       :'',
            subcategoryCount       :'',
            userCount           :'',
            productCount        :'',
            orderCount          :'',
            latestOtders        :[],
            totalOrders         :[],
            totalEarning        :0,
            currentMonthEarning : 0,
            lastMonthEarning    : 0
        }
    }

    componentDidMount(){
        if(!localStorage.getItem('userInfo')){
            window.location.href='/admin';
        }

        fetch(`${process.env['REACT_APP_HOST']}/api/categories/count/`)
        .then(response=>response.json())
        .then(result=>{
            this.setState({categoryCount:result})
        });
        fetch(`${process.env['REACT_APP_HOST']}/api/subcategories/count/`)
        .then(response=>response.json())
        .then(result=>{
            this.setState({subcategoryCount:result})
        });

        fetch(`${process.env['REACT_APP_HOST']}/api/users/count/`)
        .then(response=>response.json())
        .then(result=>{
            this.setState({userCount:result})
        });

        fetch(`${process.env['REACT_APP_HOST']}/api/products/count/`)
        .then(response=>response.json())
        .then(result=>{
            this.setState({productCount:result})
        });

        fetch(`${process.env['REACT_APP_HOST']}/api/orders/count/`)
        .then(response=>response.json())
        .then(result=>{
            this.setState({orderCount:result})
        });

        fetch(`${process.env['REACT_APP_HOST']}/api/orders/latest/`)
        .then(response=>response.json())
        .then(result=>{
            this.setState({latestOtders:result})
        });

        fetch(`${process.env['REACT_APP_HOST']}/api/orders/`)
        .then(response=>response.json())
        .then(result=>{
            this.setState({totalOrders:result})
            let total=0
            this.state.totalOrders.map((order,i)=>{
                 total=total + order.totalPrice
                this.setState({totalEarning:total})
            })
        });

        // current month's earning
        fetch(`${process.env['REACT_APP_HOST']}/api/orders/currentMonth`)
        .then(response=>response.json())
        .then(result=>{
            this.setState({totalOrders:result})
            let total=0
            result.map((order,i)=>{
                 total=total + order.totalPrice
                this.setState({currentMonthEarning:total})
            })
        });

        // last month's earning
        fetch(`${process.env['REACT_APP_HOST']}/api/orders/lastMonth`)
        .then(response=>response.json())
        .then(result=>{
            let total=0
            result.map((order,i)=>{
                 total=total + order.totalPrice
                this.setState({lastMonthEarning:total})
            })
        });
    }

    render() {
        const lineData = {
            labels: ['100', '200', '300', '400', '500', '600', '700', '800'],
            datasets: [
                {
                    lagend: 'none',
                    data: [2.5, 3, 3, 0.9, 1.3, 1.8, 3.8, 1.5],
                    borderColor: "#2c397b",
                    backgroundColor: "#2c397b",
                    borderWidth: 2
                },
                {
                    lagend: 'none',
                    data: [3.8, 1.8, 4.3, 2.3, 3.6, 2.8, 2.8, 2.8],
                    borderColor: "#a5a5a5",
                    backgroundColor: "#a5a5a5",
                    borderWidth: 2
                }
            ]
        };

        const buyData = {
            labels: ["", "10", "20", "30", "40", "50"],
            datasets: [{
                backgroundColor: "transparent",
                borderColor: "#cb3439",
                data: [20, 5, 80, 10, 100, 15],
            },
            {
                backgroundColor: "transparent",
                borderColor: "#a5a5a5",
                data: [0, 50, 20, 70, 30, 27],
            },
            {
                backgroundColor: "transparent",
                borderColor: "#2c397b",
                data: [0, 30, 40, 10, 86, 40],
            }]
        }

        const doughnutOptions = {
            title: "",
            pieHole: 0.35,
            pieSliceBorderColor: "none",
            colors: ['#2c397b', '#cb3439', '#a5a5a5'],
            legend: {
                position: "none"
            },
            pieSliceText: "none",
            tooltip: {
                trigger: "none"
            },
            animation: {
                startup: true,
                easing: 'linear',
                duration: 1500,
            },
            chartArea: { left: 0, top: 10, width: '360px', height: '100%' },
            enableInteractivity: false,
        }
        const pieOptions = {
            title: "",
            pieHole: 1,
            slices: [
                {
                    color: "#2c397b"
                },
                {
                    color: "#cb3439"
                },
                {
                    color: "#f0b54d"
                },
            ],
            tooltip: {
                showColorCode: false
            },
            chartArea: { left: 0, top: 10, width: '360px', height: '100%' },
            legend: "none"
        };
        const LineOptions = {
            hAxis: {
                textPosition: 'none', baselineColor: 'transparent',
                gridlineColor: 'transparent',
            },
            vAxis: {
                textPosition: 'none', baselineColor: 'transparent',
                gridlineColor: 'transparent',
            },
            colors: ['#2c397b'],
            legend: 'none',
        }
        const LineOptions1 = {
            hAxis: {
                textPosition: 'none', baselineColor: 'transparent',
                gridlineColor: 'transparent',
            },
            vAxis: {
                textPosition: 'none', baselineColor: 'transparent',
                gridlineColor: 'transparent',
            },
            colors: ['#cb3439'],
            chartArea: { left: 0, top: 0, width: '100%', height: '100%' },
            legend: 'none',
        }
        const LineOptions2 = {
            hAxis: {
                textPosition: 'none', baselineColor: 'transparent',
                gridlineColor: 'transparent',
            },
            vAxis: {
                textPosition: 'none', baselineColor: 'transparent',
                gridlineColor: 'transparent',
            },
            colors: ['#f5ce8a'],
            chartArea: { left: 0, top: 0, width: '100%', height: '100%' },
            legend: 'none',
        }
        const LineOptions3 = {
            hAxis: {
                textPosition: 'none', baselineColor: 'transparent',
                gridlineColor: 'transparent',
            },
            vAxis: {
                textPosition: 'none', baselineColor: 'transparent',
                gridlineColor: 'transparent',
            },
            colors: ['#a5a5a5'],
            chartArea: { left: 0, top: 0, width: '100%', height: '100%' },
            legend: 'none',
        }
        return (

            <Fragment>
                <Breadcrumb title="Dashboard" parent="Dashboard" />
                <div className="container-fluid">
                    {/* <div className="row"> */}
                        <div className="row dashboardRow" >
                            <div className="col-xl-3 col-md-6">
                                <div className="card o-hidden widget-cards">
                                    <div className="card-body bg1">
                                        <div className="media static-top-widget">
                                             <h3 className="mb-0">$<CountUp className="counter" end={this.state.totalEarning} /></h3>
                                            <div className="icons-widgets col-4">
                                                    <div className="align-self-center text-center"><DollarSign className="font-warning" /></div>
                                            </div>
                                        </div>
                                        <span className="m-0 headng">Total Earning</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-3 col-md-6 ">

                                <div className="card o-hidden  widget-cards">
                                    <div className="card-body bg2">
                                        <div className="media static-top-widget row">
                                            <div className="media-body col-8">
                                                <h3 className="mb-0"><CountUp className="counter" end={this.state.categoryCount} /></h3>
                                                
                                            </div>
                                            <div className="icons-widgets col-4">
                                                <div className="align-self-center text-center"><List className="font-secondary" /></div>
                                            </div>
                                        </div>
                                        <span className="m-0 headng">Total Categories</span>
                                    </div>
                                </div>
                            </div>

                            <div className="col-xl-3 col-md-6">

                                <div className="card o-hidden  widget-cards">
                                    <div className="card-body bg3">
                                        <div className="media static-top-widget row">
                                            <div className="media-body col-8">
                                                <h3 className="mb-0"><CountUp className="counter" end={this.state.subcategoryCount} /></h3>
                                                   
                                            </div>
                                            <div className="icons-widgets col-4">
                                                <div className="align-self-center text-center"><Box className="font-secondary" /></div>
                                            </div>
                                        </div>
                                        <span className="m-0 headng">Total Sub Categories</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-3 col-md-6">

                                <div className="card o-hidden widget-cards">
                                    <div className="card-body bg4">
                                        <div className="media static-top-widget row">
                                          <div className="media-body col-8">
                                                <h3 className="mb-0"><CountUp className="counter" end={this.state.productCount} /></h3>
                                                
                                            </div>
                                            <div className="icons-widgets col-4">
                                                <div className="align-self-center text-center"><BookOpen className="font-primary" /></div>
                                            </div>
                                        </div>
                                        <span className="m-0 headng">Total Courses</span>
                                    </div>
                                </div>
                            </div>
                        </div>    
                        <div className="row">
                            <div className="col-xl-3 col-md-6">
                                <div className="card o-hidden widget-cards">
                                    <div className=" card-body bg5">
                                        <div className="media static-top-widget row">
                                        <div className="media-body col-8">
                                                <h3 className="mb-0"><CountUp className="counter" end={this.state.orderCount} /></h3>
                                                
                                            </div>
                                            <div className="icons-widgets col-4">
                                                <div className="align-self-center text-center"><ShoppingBag className="font-danger" /></div>
                                            </div>
                                            
                                        </div>
                                        <span className="m-0 headng">Total orders</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-3 col-md-6">
                                <div className="card o-hidden widget-cards">
                                    <div className="card-body bg6">
                                        <div className="media static-top-widget row">
                                            <div className="media-body col-8">
                                                <h3 className="mb-0"><CountUp className="counter" end={this.state.userCount} /></h3>
                                                
                                            </div>
                                            <div className="icons-widgets col-4">
                                                <div className="align-self-center text-center"><Users className="font-info" /></div>
                                            </div>
                                        </div>
                                        <span className="m-0 headng">Total Users</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-3 col-md-6">
                                <div className="card o-hidden widget-cards">
                                    <div className="card-body bg7">
                                        <div className="media static-top-widget row">
                                             <div className="media-body col-8">
                                                <h3 className="mb-0">$<CountUp className="counter" end={this.state.currentMonthEarning} /></h3>
                                                
                                            </div>
                                            <div className="icons-widgets col-4">
                                                <div className="align-self-center text-center"><DollarSign className="font-success" /></div>
                                            </div>
                                            
                                        </div>
                                        <span className="m-0 headng">Current Month's Earning</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <div className="row">
                        <div className="col-xl-4 col-md-6 xl-50">
                                <div className="card o-hidden widget-cards">
                                    <div className="bg-primary card-body">
                                        <div className="media static-top-widget row">
                                            <div className="icons-widgets col-4">
                                                <div className="align-self-center text-center"><Navigation className="font-primary" /></div>
                                            </div>
                                            <div className="media-body col-8"><span className="m-0">Last Month's Earning</span>
                                                <h3 className="mb-0">$ <CountUp className="counter" end={this.state.lastMonthEarning} /></h3>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> */}
                    <div className="row">    
                        {/* <div className="col-xl-6 xl-100">
                            <div className="card">
                                <div className="card-header">
                                    <h5>Market Value</h5>
                                </div>
                                <div className="card-body">
                                    <div className="market-chart">
                                        <Bar data={lineData} options={lineOptions} width={778} height={308} />
                                    </div>
                                </div>
                            </div>
                        </div> */}
                        
                        
                           

                        <div className="col-xl-12 col-lg-12 col-md-12 xl-100" style={{marginTop:"40px"}}>
                            <div className="card">
                                <div className="card-header">
                                    <h5>Latest Orders</h5>
                                </div>
                                <div className="card-body">
                                    <div className="user-status table-responsive latest-order-table">
                                        <table className="table table-bordernone">
                                            <thead>
                                                <tr>
                                                    <th scope="col">SN</th>
                                                    <th scope="col">Order ID</th>
                                                    <th scope="col">Order Total</th>
                                                    <th scope="col">Status</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                            {
                                            this.state.latestOtders.map((Order,i)=>{
                                                // console.log(Order.totalPrice)
                                                return(
                                                <tr>
                                                    <td>{i+1}</td>
                                                    <td>{Order._id}</td>
                                                    <td className="digits">{Order.totalPrice}</td>
                                                    {/* <td className="font-danger">{Order.paymentResult.type}</td> */}
                                                    
                                                    {/* <td className="digits">{Order.isPaid=true ? 'Success' : 'Failed'}</td> */}
                                                    <td className="digits">{Order.isPaid=true ?  <span className="text-success">Success</span> : <span className="text-danger"> 
                                                        Failed
                                                    </span>}</td>
                                                </tr>
                                                )
                                                })
                                            }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* <div className="col-xl-4 col-md-6 xl-50">
                                <div className="card o-hidden widget-cards">
                                    <div className="bg-primary card-body">
                                        <div className="media static-top-widget row">
                                            <div className="icons-widgets col-4">
                                                <div className="align-self-center text-center"><Navigation className="font-primary" /></div>
                                            </div>
                                            <div className="media-body col-8"><span className="m-0">Last Month's Earning</span>
                                                <h3 className="mb-0">$ <CountUp className="counter" end={this.state.lastMonthEarning} /></h3>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>                     */}


                    </div>
                    </div>
                {/* </div> */}
            </Fragment>

        )
    }
}
// javascript:void(0)

export default Dashboard
